import React from "react";
import {
  downloadOnAppStoreClicked,
} from "utils/segment";

import AppStoreLogo from "../assets/appstore-button.svg";
import PlayStoreLogo from "../assets/playstore-button.svg";

export default () => {
    return (
      <div className="app-buttons">
        <a
          href="https://apps.apple.com/us/app/papa-pal/id1498631076"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            downloadOnAppStoreClicked({ appStore: "App Store" });
          }}
        >
          <img
            data-src={AppStoreLogo}
            alt="App Store"
            className="appstore lazyload application-store-logo"
          />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=com.joinpapa.papapal"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => {
            downloadOnAppStoreClicked({ appStore: "Google Play" });
          }}
        >
          <img
            data-src={PlayStoreLogo}
            alt="Play Store"
            className="playstore lazyload application-store-logo"
          />
        </a>
      </div>
    );
}